<template lang="pug">
.strip(v-show="true || !hasCheatsheet", :class="{ 'for-folderlist': folderList }")
  .player-wrap(v-if="currentVideo")
    keep-alive
      player
  .headers.top(v-if="!folderList && !roboWeaveShown && !engage")
    .header.selected Themes
  //-.docs(ref="topDocs", v-if="false")
  //-  .items(v-if="someDocuments")
  //-    .item(v-for="(doc, i) in documents",
  //-          :style="{ 'background-image': topDocVisible[i] && `url('${ doc.imgu }')` }",
  //-          @click="selectDoc(doc)",
  //-          :class="{ selected: doc.selected, 'has-insight': doc.kt.length }")
  //-.options
    .tabs
      button-tab.right.white.list.selector(id="selector")
        template(slot="title") .
        template(slot="content")
          label
            input(type="radio", value="all" v-model="selectAll")
            | all
          label
            input(type="radio", value="none", v-model="selectAll")
            | none
          label.disabled
            input(type="radio", value="relevant", v-model="selectAll")
            | relevant
          label
            input(type="radio", value="custom", v-model="selectAll", :class="{ disabled: !Object.keys(customSelection).length }")
            | custom
      button-tab.right.white.list.sort(id="sort")
        template(slot="title") sort
        template(slot="content")
          //optgroup
          label
            input(type="radio", value="ascending" v-model="docSort")
            | ascending
          label
            input(type="radio", value="descending", v-model="docSort")
            | descending
          label
            input(type="radio", value="relevance", v-model="docSort")
            | relevance
          label
            input(type="radio", value="visual interest", v-model="docSort")
            | visual interest
  .tag-bar(v-if="!folderList && !roboWeaveShown && !engageShown")
    .filters(v-if="selectedTagsLength", :class="{ searchFocus: 0 }")
      //.filter.command(v-if="cloud === false", @click="cloud = true")
      .filter.tag(@click="untag(text)",
                  v-for="(value, text) in selectedTags") {{ text }}
    //.open(v-else-if="cloud === false",
    //      @click="cloud = true",
    //      :class="{ searchFocus: 0 }") Filter
  .theme-builder(v-if="!engageShown", :class="{ shown: newTheme }", @click.self="closeThemer()")
    .themer(v-if="newTheme")
      global-events(@keyup.esc="closeThemer(true)")
      .close(@click="closeThemer()") &times;
      label.name
        input(v-model="themeName", placeholder="add theme name")
      facets-lite(theme-path="newTheme")
  facets(NOnamespace="documentsNS", v-if="!roboWeaveShown && !engageShown")
  insights(v-if="!engageShown")
  .blank(v-if="engageShown")
    .logo.pulse
      .ring
      .pulse-ring

  .docs(v-if="lazyLevel < 95 && !lens")
    .info
      .count
        .primary
          //.value {{ filteredDocsWithInsights.map(d => d.pgn).filter(pgn => selectedDocuments[pgn]).length }}
          .value {{ selectedDocs.length }}
          |  selected
        .secondary(v-if="filteredDocs && filteredDocs.length > 1")  (of&nbsp;
          .value {{ filteredDocs.length }}
          |  page{{ filteredDocs.length > 1 && 's' || '' }})
    .options(v-if="!engage")
      cheatsheet-controls(shareKey="pages", :hideSelect="true", :payload="payload(true)")
      //lp-switcher.cheatsheet-preview(v-if="lp",
      //                               v-model="lp",
      //                               :options="lps",
      //                               title="Open Cheatsheet in a new window",
      //                               @input="swicthed")
      ////a.cheatsheet-preview(v-if="lp", target="_blank", :href="`?${ lp }`", title="Open Cheatsheet in a new window") {{ lp }}
      //.share(@click="save(true)", :class="{ pressed: shareClicked === 1 }", title="Share") share
      .tabs
        button-tab.right.white.list.selector.no-dot(id="selector")
          template(slot="title") .
          template(slot="content")
            label
              input(type="radio", value="all" v-model="selectAll")
              | all
            label
              input(type="radio", value="none", v-model="selectAll")
              | none
            label.disabled
              input(type="radio", value="relevant", v-model="selectAll")
              | relevant
            label
              input(type="radio", value="custom", v-model="selectAll", :class="{ disabled: !Object.keys(customSelection).length }")
              | custom
        button-tab.right.white.list.sort.no-dot(id="sort")
          template(slot="title") sort
          template(slot="content")
            //optgroup
            label
              input(type="radio", value="ascending" v-model="docSort")
              | ascending
            label
              input(type="radio", value="descending", v-model="docSort")
              | descending
            label
              input(type="radio", value="relevance", v-model="docSort")
              | relevance
            label
              input(type="radio", value="visual interest", v-model="docSort")
              | visual interest
    .items(v-if="filteredDocs", ref="filteredDocs")
      .item(v-for="(doc, i) in filteredDocs",
            vNOTDASHobserver="observer",
            :id="`obd|${ doc.imgu }`",
            v-lazy:background-image="doc.imgu",
            NOTstyle="{ 'background-image': inView(`obd|${ doc.imgu }`) && `url('${ doc.imgu }')` }",
            @click="altSelectDoc(doc.pgn)",
            :class="{ selected: selected(doc), 'has-insight': doc.kt.length }")
        //-@click="doc.kt.length && altSelectDoc(doc.pgn) || viewPDF(doc.url)",
        .goto-insight(v-if="doc.kt.length", @click.stop="gotoInsight(doc.pgn)") &curren;
        .goto-pdf(@click.stop="viewPDF(doc.url)") view pdf
  .analysis(v-if="lazyLevel < 80 && !engageShown", v-observe-visibility="insightsVisibilityChanged")
    .headers(ref="headers", :style="{ visibility: lens && 'hidden' || 'visible' }")
      .header(@click="pdfView = cloud = false", :class="{ selected: !cloud && !pdfView }") Talking Points
      .header(@click="(cloud = true) && (pdfView = false)", :class="{ selected: cloud }") Topics
      .header(@click="(pdfView = true) && (cloud = false)",
              :class="{ selected: pdfView }",
              v-if="pdf") Viewer
    //-.inherit(v-if="Object.keys(store.getters.selectedAllTags).length")
    //-  button-tab.right.white.list.inheritUpper(id="inheritUpper")
    //-    template(slot="title") Inherit Upper Tags
    //-    template(slot="content")
    //-      .reset(@click="reset('InheritUpper')")
    //-      label.switch-light.switch-candy
    //-          input(type="checkbox", v-model="inheritUpper")
    //-          strong Inherit Upper Tags
    //-          span
    //-            span Off
    //-            span On
    //-            a
    //-  //-label
    //-  //-  input(type="checkbox", v-model="inheritUpper")
    //-  //-  |  inherit upper tags
    facets(namespace="insightsNS", v-if="!lens")
    .views
      .viewport(:class="{ cloud, pdfView, 'for-folderlist': folderList }")
        .insights(v-if="insightsVisible && !lens")
          .nav(v-if="false && isWindows")
            .prev(@click="insightsPrev") <
            .next(@click="insightsNext") >
          cheatsheet-controls(:hasCheatsheet="hasCheatsheet", :payload="payload()")
          .count
            .primary
              .value {{ insightsCount }}
              |  insight{{ insightsCount > 1 && 's' || '' }}
            .secondary(v-if="insightsCount > 1")  (on&nbsp;
              .value {{ insightDocs.length }}
              |  page{{ insightDocs.length > 1 && 's' || '' }})
          .items(v-if="filteredDocs", ref="items", :class="{ sharing }")
            //- todo: lazy load images
            //-.item(v-for="({ pgn, selected, kti, imgu, url }, i) in filteredDocsWithInsights",
            //- .item(v-for="({ pgn, selected, kti, imgu, url }, i) in docsWithFilteredKTIs",
            .item(v-for="({ pgn, selected, kti, imgu, url }, i) in insightDocs",
                  v-lazy:background-image="imgu",
                  vNOTDASHobserver="observer",
                  :id="`obi|${ imgu }`",
                  :pgn="pgn",
                  v-if="filtered(kti).length",
                  NOTstyle="{ 'background-image': inView(`obi|${ imgu }`) && `url('${ imgu }')` || '' }",
                  @click="(pdf = url) && (pdfView = true)",
                  :class="{ selected }")
              .selectors
                .all(title="Select all", @click.stop="selectInsights(kti, imgu, true)") all
                .none(title="Select none", @click.stop="selectInsights(kti, imgu, false)") none
                clipboard(:items="filtered(kti).filter((t, i) => i <= 5).map((t, i) => [`ic|${ readInsightKey(insightKey(imgu, t)).pgn }|${ insightKey(imgu, t) }`, t.k, i])")
              ul
                //-li(v-for="(t, i) in filtered(kti)", :class="{ more: i > 5 }") {{ t.k }}
                li(v-for="(t, i) in filtered(kti)",
                   :title="sharing && (selectedInsights[insightKey(imgu, t)] && 'Deselect' || 'Select') || ''",
                   @click.stop.prevent="sharing && selectInsight(insightKey(imgu, t))",
                   :class="{ more: i > 5, selected: selectedInsights[insightKey(imgu, t)] }")
                  highlighter(v-if="selectedTagsWithAliases.length",
                              :text-to-highlight="t.k",
                              :case-sensitive="true",
                              highlight-class-name="theme",
                              highlight-tag="span",
                              :d-search-words="selectedTagsWithAliases",
                              :search-words="selectedTagsWithAliases")
                  div(v-else) {{ t.k }}
                  clipboard(:id="`ic|${ readInsightKey(insightKey(imgu, t)).pgn }|${ insightKey(imgu, t) }`", :text="t.k", :index="i")
        .tag-cloud(:class="{ cloud }", v-if="lazyLevel < 40 && !lens")
          vue-word-cloud(:words="Object.entries(allTagsFiltered || insightTagsFiltered)",
                         :animationDuration="0",
                         v-if="cloudOnce",
                         :color="color"
                         :rotation="rotation",
                         font-family="Roboto")
            template(slot-scope="{ word, text, weight }")
              .word(NOTstyle="cursor: pointer;", :title="weight", NOTATclick="tag(word)") {{ text }}
          //vue-word-cloud(:words="Object.entries(allTagsFiltered || insightTagsFiltered)",
          //               :animationDuration="0",
          //               :color="color"
          //               :rotation="rotation",
          //               :progress.sync="progress",
          //               font-family="Roboto")
          //  template(slot-scope="{ word, text, weight }")
          //    .word(NOTstyle="cursor: pointer;", :title="weight", NOTATclick="tag(word)") {{ text }}
          //viewer(v-if="lazyLevel < 50")
        folder
        viewer(v-if="(lens || lazyLevel < 50) && !engage")
        //-.viewer(v-if="lazyLevel < 50")
        //-  .zoom-level(title="toggle zoom", @click="zoomLevel = zoomLevel === 1 && 0.45 || 1") {{ zoomLevel * 100 + '%' }}
        //-  .toc(ref="tocPages", @scroll.passive="tocScroll")
        //-    .pages
        //-      .page(v-for="({ pgn, selected, imgu, url }, i) in insightDocs",
        //-            :style="{ 'background-image': tocDocsVisible[i] && imgu && `url('${ imgu }')` || ''}",
        //-            :class="{ selected: pdf === url, enabled: !mutex }"
        //-            @click="tocClick(url)")
        //-        .number {{ pgn }}
        //-  pdf.pdf(:src="pdf", :style="{ transform: `scale(${ zoomLevel })` }")
        //-  .next.top(:class="{ enabled: !mutex }", :title="`go to page ${ nextPage }`", @click="gotoPage()") {{ nextPage }}
        //-  .current.top(title="current page") {{ currentPage }}
        //-  .previous.top(:class="{ enabled: !mutex }", :title="`go to page ${ previousPage }`", @click="gotoPage(true)") {{ previousPage }}
        //-  .next.bottom(:class="{ enabled: !mutex }", :title="`go to page ${ nextPage }`", @click="gotoPage()") {{ nextPage }}
        //-  .current.bottom(title="current page") {{ currentPage }}
        //-  .previous.bottom(:class="{ enabled: !mutex }", :title="`go to page ${ previousPage }`", @click="gotoPage(true)") {{ previousPage }}
  robo
  watchlist(v-if="watchlist")
  engage(v-if="engage")
  .charts(:class="{ shown: chartShown, 'see-through': roboReportMinimized }")
    global-events(v-if="analytics && !selectedParentTheme", @keyup.esc="chartShown && (chartShown = false)")
    comparer(v-if="analytics")
  //-.charts(:class="{ shown: chartShown }")
  //-  bar-chart(v-if="analytics", :class="{ shown: hoverTheme }")
  //-  chord-chart(v-if="analytics")
  doc-zoomer(v-if="folderList || (engageShown && engageSection)", :style="engageShown && { 'z-index': 1000 } || {}")
  .test(v-else)
  .hello
  .doco-publisher(v-if="docoPublisher && !roboWeaveShown")
    .logo(:style="{ 'background-image': `url('${ docoPublisher.logo }')` }")
    .name {{ docoPublisher.name }}
  .engage-publisher(v-else-if="engage && engageShown")
    .logo(:style="{ 'background-image': `url('https://content.weave.ai/picture-images/${ engage.publisher.key }-logo.jpg')` }")
    .name {{ engage.publisher.n }}
      span.favorite(:title="`${ isFavorite && 'remove' || 'add' } ${ engage.publisher.n } ${ isFavorite && 'from' || 'to' } your favorites`",
        :class="{ hide: authStatusLabel !== 'auth' }")
        svg(:class="{ on: isFavorite }",
            @click="togglePubFavorite",
            xmlns="http://www.w3.org/2000/svg",
            width="64.000000pt",
            height="64.000000pt",
            viewBox="0 0 64.000000 64.000000",
            preserveAspectRatio="xMidYMid meet")
          g(transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)")
            path(d="M121 514 c-42 -35 -56 -87 -41 -144 9 -37 29 -62 104 -135 50 -50 100 -101 109 -115 18 -24 18 -25 29 -5 6 11 55 63 109 115 110 107 131 150 110 221 -26 86 -133 119 -200 63 l-31 -26 -31 26 c-43 36 -115 37 -158 0z")

</template>
<script>
//import VueWordCloud from 'vuewordcloud';
import highlighter from 'vue-highlight-words';
import pdf from 'vue-pdf';
import buttonTab from '@/components/topo-components/button-tab';
import facets from '@/components/topo-components/facets';
import facetsLite from '@/components/topo-components/facets-lite';
import lpSwitcher from '@/components/topo-components/lp-switcher';
import cheatsheetControls from '@/components/topo-components/cheatsheet-controls';
import clipboard from '@/components/clipboard';
import viewer from '@/components/topo-components/viewer';
import insights from '@/components/topo-components/insights';
import docZoomer from '@/components/doc-zoomer';
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
import { vuexComputedNamespace, licensePlate } from '../helpers';
let observer;
export default {
  name: 'strip',
  data() {
    return {
      // topDocVisible: {},
      // filteredDocsVisible: { 0: 1, 1: 1, 2: 1, 3: 1 },
      // tocDocsVisible: {},
      invalidator: 1,
      scrolled: 0,
      ready: false,
      pgress: undefined,
      mutex: null,
      timer: null,
      onScreen: {},
      cloudOnce: false
    };
  },
  watch: {
    doco() {
      if (!this.lens) {
        console.log('doco watcher');
        this.onScreen = {};
        this.$refs.filteredDocs.scrollTo(0, 0);
        this.$refs.items.scrollTo(0, 0);
      }
    },
    cloud() {
      this.cloudOnce = true;
    }
  },
  computed: {
    ...mapGetters([
      'documents',
      'someDocuments',
      'customSelection',
      'selectedTags',
      'selectedAllTags',
      'selectedTagsLength',
      'filteredDocs',
      'filteredDocsWithInsights',
      'insightTagsFiltered',
      'selectedDocuments',
      'aliases',
      'lpServer',
      'doco',
      'docoPublisher',
      'lens',
      'folderList',
      'robo',
      'roboWeaveShown',
      'roboReportMinimized',
      'currentVideo',
      'hoverTheme',
      'analytics',
      'selectedParentTheme',
      'watchlist',
      'engage',
      'engageShown',
      'engageSection',
      'authStatusLabel',
      'au'
    ]),
    ...mapGetters('insightsNS', ['selectedInsights', 'hasCheatsheet', 'insightsForCheatSheet']),
    ...vuexComputed(
      'docSort',
      'selectAll',
      'cloud',
      'pdf',
      'pdfView',
      'lazyLevel',
      'zoomLevel',
      'sharing',
      'lp',
      'token',
      'lps',
      'shareClicked',
      'insightsVisible',
      'chartShown',
      'newTheme'
    ),
    isFavorite() {
      return this.au?.fr?.includes('p');
    },
    themeName: {
      get() {
        return this.newTheme?.n;
      },
      set(value) {
        this.$store.dispatch('setThemeName', { themePath: 'newTheme', name: value });
      }
    },
    observer() {
      return observer;
    },
    insightDocs() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //this.invalidator = new Date() * 1;
      return this.$store.getters['insightsNS/docsWithFilteredKTIs'];
    },
    insightsCount() {
      return this.insightDocs?.reduce((count, { kti }) => count + kti.length, 0);
    },
    namespace() {
      return 'insightsNS';
    },
    selectedDocs() {
      const { filteredDocs, selectedDocuments } = this;
      return filteredDocs?.filter(({ pgn }) => selectedDocuments[pgn]) || [];
    },
    //...vuexComputedNamespace('sentimentQuantiles', 'volumeQuantiles', 'allTagsFiltered', 'docsWithFilteredKTIs'),
    ...vuexComputedNamespace('sentimentQuantiles', 'volumeQuantiles', 'allTagsFiltered'),
    insightSelectedTags() {
      return Object.keys(this.$store.getters['insightsNS/selectedTags'] || {});
    },
    selectedTagsWithAliases() {
      const { insightSelectedTags, selectedAllTags, aliases } = this;
      return Array.from(new Set(Object.keys(selectedAllTags).concat(insightSelectedTags))).reduce(
        (all, tag) => all.concat((aliases[tag] || tag).split('|')),
        []
      );
    },
    currentPage() {
      const { documents, pdf } = this;
      return documents.filter(({ url }) => url === pdf)[0]?.pgn;
    },
    nextPage() {
      const { currentPage, getPageByPgn } = this;
      return getPageByPgn(currentPage + 1)?.pgn || '';
    },
    previousPage() {
      const { currentPage, getPageByPgn } = this;
      return getPageByPgn(currentPage - 1)?.pgn || '';
    },
    page() {
      const {
        $refs: { items },
        scrolled,
        invalidator
      } = this;
      let r = 0;
      if ((scrolled || invalidator) && items) {
        const { scrollLeft, scrollWidth, clientWidth } = items;
        const width = scrollWidth - clientWidth;
        const progress = scrollLeft / width;
        const percentPerPage = clientWidth / width;
        r = progress / percentPerPage;
      }
      return Math.floor(r) + 1;
    },
    insightItemWidth() {
      const {
        $refs: { items }
      } = this;
      console.log('items: ', items);
      const [one, two, three, four] = items?.querySelectorAll('.item');
      const left = one?.getBoundingClientRect().left;
      let right = (two && two?.getBoundingClientRect().left) || left + 800;
      if (left === right && three) {
        right = three?.getBoundingClientRect().left;
      }
      if (left === right && four) {
        right = four?.getBoundingClientRect().left;
      }
      return right;
    },
    /*currentPages() {
      const { page } = this;
      return [page - 1, page, page + 1];
    },
    assignPages() {
      const {
        $refs: { items },
        invalidator,
        ready
      } = this;
      let r;
      if (invalidator && items && ready) {
        const { scrollLeft, scrollWidth, clientWidth } = items;
        const width = scrollWidth - clientWidth;
        const percentPerPage = clientWidth / width;
        r = Array.from(items.querySelectorAll('.item'), item =>
          Math.ceil((item.getBoundingClientRect().left + scrollLeft) / scrollWidth / percentPerPage)
        );
      }
      return r;
    },*/
    progress: {
      get() {
        return this.pgress;
      },
      set(value) {
        window.pgress = value;
        this.pgress = value;
      }
    },
    isWindows() {
      return isWindows();
    }
  },
  methods: {
    ...mapActions(['selectDoc', 'addLoader', 'removeLoader', 'removeTheme', 'togglePubFavorite']),
    ...mapActions('insightsNS/', ['selectInsight']),
    closeThemer(force) {
      console.log('closeThemer', this.newTheme);
      const { newTheme: { id, n, selectedTags }, removeTheme } = this;
      const clear = () => {
        this.$notify({
          group: 'tb',
          clean: true
        });
      };
      const close = () => {
        this.newTheme = null;
        clear();
      };
      const remove = () => {
        close();
        removeTheme(id);
      };
      const noSelectedTags = !Object.keys(selectedTags).length;
      if (!n) {
        if (force || noSelectedTags) {
          remove();
        } else {
          //toast
          //console.log('toast');
          clear();
          this.$notify({
            group: 'tb',
            title: 'Name is required',
            text: 'Press the escape key to delete',
            width: '30%',
            duration: 25000
          });
        }
      } else {
        close();
      }
    },
    insightsVisibilityChanged(isVisible) {
      this.insightsVisible = isVisible;
    },
    getPageByPgn(number) {
      return this.documents.filter(({ pgn }) => pgn === number)[0];
    },
    gotoPage(previous) {
      const number = this[(previous && 'previousPage') || 'nextPage'];
      if (number) {
        const { url } = this.getPageByPgn(number) || {};
        if (url) {
          clearTimeout(this.timer);
          const delay = (isWinChrome() && 1000) || 0;
          const click = () => {
            this.pdf = url;
            this.mutex = null;
          };
          if (this.mutex) {
            this.timer = setTimeout(click, delay);
          } else {
            click();
            this.mutex = 1;
            this.timer = setTimeout(() => (this.mutex = null), delay);
          }
          this.pdf = url;
        }
      }
    },
    gotoInsight() {
      // todo: implement this
      // todo: handle case where insight page is not selected so will not have an insight: auto select?
      this.pdfView = false;
      this.cloud = false;
      this.scrollToLower();
    },
    untag(item) {
      this.store.dispatch('tag', { item, value: 0 });
    },
    altSelectDoc(pgn) {
      const [doc] = this.documents.filter(d => d.pgn === pgn);
      doc && this.selectDoc(doc);
      return 1;
    },
    random(max = 10) {
      return Math.round(Math.random() * max);
    },
    rotation([, weight]) {
      return (weight > 30 && 0.75) || 0;
    },
    color([, weight]) {
      return (weight > 30 && 'orange')
          || (weight > 10 && '#8d6e4f')
          || '#282828';
    },
    filtered(kti) {
      const { sentimentQuantiles, volumeQuantiles } = this;
      return kti.filter(({ sq, vq }) => sentimentQuantiles.includes(sq) && volumeQuantiles.includes(vq));
    },
    /*tocScroll() {
      //console.log('tocScroll');
      this.tocDocsVisible = arrayFromScrollTop(this.$refs.tocPages.scrollTop);
      function arrayFromScrollTop(scrollTop) {
        const offset = Math.floor(scrollTop / 228);
        return Array.from(new Array(20), (item, i) => i + offset).reduce((map, item) => ({ ...map, [item]: 1 }), {});
      }
    },*/
    tocClick(url) {
      const { mutex } = this;
      const delay = (isWinChrome() && 1000) || 0;
      const click = () => {
        this.mutex = null;
        this.pdf = url;
        this.pdfView = true;
      };
      clearTimeout(this.timer);
      if (mutex) {
        this.timer = setTimeout(click, delay);
      } else {
        click();
        this.mutex = 1;
        this.timer = setTimeout(() => (this.mutex = null), delay);
      }
    },
    viewPDF(url) {
      this.tocClick(url);
      this.scrollToLower();
    },
    scrollToLower() {
      // window.scrollBy(0, this.$refs.headers.getBoundingClientRect().top - 40);
      window.scrollBy({ behavior: 'smooth', top: this.$refs.headers.getBoundingClientRect().top - 40 });
    },
    reset(type) {
      this.$store.dispatch('reset' + type);
    },
    selected({ pgn }) {
      return this.selectedDocuments[pgn];
    },
    selectInsights(kti, imgu, select) {
      const { filtered, selectInsight, sharing, insightKey } = this;
      if (sharing) {
        filtered(kti).forEach((t, i) => i < 6 && selectInsight({ key: insightKey(imgu, t), select }));
      }
    },
    insightKey(imgu, { w, k }) {
      let text = k;
      try {
        text = btoa(text.replace(/[\u00A0-\u2666]/g, c => '&#' + c.charCodeAt(0) + ';'));
      } catch (ex) {
        // console.log('could not base64 encode', ex, '\n\n\n\n\n\n');
        // console.log('text', text), '\n\n\n\n\n';
      }
      return `${ imgu.replace(
        /^https\:\/\/d23xtmsrsmj88h\.cloudfront\.net\/picture\-images\/|\.png$/g,
        ''
      ) }|${ w.toPrecision(6) }|${ text }`;
    },
    readInsightKey(key) {
      let did;
      let pgn;
      let w;
      let k;
      key.replace(/^([^\|]+?)\-(\d+)\|([\d\.]+)\|(.+)/, (match, p1, p2, p3, p4) => {
        did = p1;
        pgn = p2;
        w = p3;
        try {
          k = atob(p4);
        } catch (ex) {}
      });
      // return JSON.stringify({ did, pgn, w, k });
      return { did, pgn, w, k };
    },
    payload(pages) {
      const { insightsForCheatSheet, selectedDocs } = this;
      const r = {};
      if (pages) {
        if (selectedDocs) {
          const dids = selectedDocs.reduce((all, { did }) => {
            all[did] = all[did] || [];
            return all;
          }, {});
          selectedDocs.forEach(({ did, pgn }) => dids[did].push(pgn));
          r.pages = dids;
          //filteredDocuments.filter(({ pgn }) => selectedDocuments[pgn]).map(({ id }) => id)
        }
      }
      if (insightsForCheatSheet?.length) {
        r.insights = insightsForCheatSheet;
      }
      return r;
    },
    // async save(pages) {
    //   const { insightsForCheatSheet, $cookie, selectedDocs, lpServer, addLoader, removeLoader } = this;
    //   //let l = this.$cookie.get('lp') || licensePlate();
    //   this.shareClicked = (pages && 1) || 2;
    //   //nextTick(() => this.shareClicked = false);
    //   setTimeout(() => (this.shareClicked = false), 250);
    //   let l = this.lp || licensePlate();
    //   if (!/^c/.test(l)) {
    //     l = 'c' + l;
    //   }
    //   console.log('save', l);
    //   //const payload = {};
    //   const payload = {};
    //   if (pages) {
    //     if (selectedDocs) {
    //       const dids = selectedDocs.reduce((all, { did }) => {
    //         all[did] = all[did] || [];
    //         return all;
    //       }, {});
    //       selectedDocs.forEach(({ did, pgn }) => dids[did].push(pgn));
    //       payload.pages = dids;
    //       //filteredDocuments.filter(({ pgn }) => selectedDocuments[pgn]).map(({ id }) => id)
    //     }
    //   }
    //   if (insightsForCheatSheet?.length) {
    //     payload.insights = insightsForCheatSheet;
    //   }
    //   //const body = JSON.stringify(this.insightsForCheatSheet || '');
    //   const body = JSON.stringify(payload);
    //   console.log('body replace?', body);
    //   if (body) {
    //     try {
    //       addLoader();
    //       //const r = await fetch('http://localhost:8003/lp/cDAD-249', { method: 'PUT', body });
    //       const r = await fetch(`${ lpServer }/lp/replace/${ l }`, { method: 'PUT', body });
    //       // const { token, lp, owner } = await r.json();
    //       const { token, lp } = await r.json();
    //       //todo: move this to the store
    //       console.log('save', lp, token);
    //       if (lp) {
    //         this.lp = lp;
    //         //$cookie.set('lp', lp);
    //         const { lps } = this;
    //         if (!lps) {
    //           this.lps = [lp];
    //         } else if (!lps.includes(lp)) {
    //           lps.push(lp);
    //           this.lps = lps;
    //         }
    //         // (async () => {
    //         //   const { $localforage: lf } = this;
    //         //   const lps = (await lf.getItem('lps')) || [];
    //         //   if (!lps.includes(lp)) {
    //         //     lps.push(lp);
    //         //   }
    //         //   await lf.setItem('lps', lps);
    //         // })();
    //       } else {
    //         console.log('save no lp');
    //         console.log('saved', l, lp);
    //       }
    //       if (token) {
    //         this.token = token;
    //         $cookie.set('token', token);
    //       } else {
    //         console.log('save no token');
    //       }
    //     } catch (ex) {
    //       console.log('save, failed', ex);
    //     } finally {
    //       removeLoader();
    //     }
    //   }
    // },
    swicthed(value) {
      const { lps } = this;
      const has = lps.includes(value);
      if (!has) {
        lps.push(value);
        this.lps = lps;
      }
      console.log('swicthed', value, lps, lps.includes(value));
    },
    insightsNext() {
      const {
        $refs: { items },
        insightItemWidth
      } = this;
      const { scrollLeft, style, classList } = items;
      console.log('scrollInsights', scrollLeft, insightItemWidth, items);
      if (!classList.contains('animate')) {
        classList.add('animate');
        style.transform = `translate3d(${ -insightItemWidth }px, 0, 0)`;
        setTimeout(() => {
          console.log('timer', scrollLeft, insightItemWidth, scrollLeft + insightItemWidth);
          classList.remove('animate');
          style.transform = 'none';
          items.scrollLeft = scrollLeft + insightItemWidth;
        }, 300);
      }
    },
    insightsPrev() {
      const {
        $refs: { items },
        insightItemWidth
      } = this;
      const { scrollLeft, style, classList } = items;
      console.log('scrollInsights', scrollLeft, insightItemWidth, items);
      if (!classList.contains('animate') && scrollLeft) {
        classList.add('animate');
        style.transform = `translate3d(${ insightItemWidth }px, 0, 0)`;
        setTimeout(() => {
          console.log('timer', scrollLeft, insightItemWidth, scrollLeft + insightItemWidth);
          classList.remove('animate');
          style.transform = 'none';
          items.scrollLeft = scrollLeft - insightItemWidth;
        }, 300);
      }
    },
    enterView(entries) {
      //console.log('enter',  entries, entries.map(entry => [entry.isIntersecting, entry.target.id].join(', ')));
      const onScreen = { ...this.onScreen };
      this.onScreen = {
        ...onScreen,
        ...entries.reduce((all, { target, isIntersecting }) => {
          all[target.id] = isIntersecting;
          return all;
        }, {})
      };
      //console.log(JSON.stringify(this.onScreen, null, 2));
    },
    inView(id) {
      return this.onScreen[id];
    }
  },
  components: {
    facets,
    facetsLite,
    buttonTab,
    // VueWordCloud,
    VueWordCloud: () => import('vuewordcloud'),
    pdf,
    highlighter,
    lpSwitcher,
    cheatsheetControls,
    clipboard,
    viewer,
    insights,
    docZoomer,
    folder: () => import('@/components/folder'),
    robo: () => import('@/components/robo/index'),
    watchlist: () => import('@/components/watchlist/index'),
    engage: () => import('@/components/engage/index'),
    player: () => import('@/components/topo-components/player'),
    // barChart: () => import('@/components/topo-components/bar-chart'),
    // chordChart: () => import('@/components/topo-components/chord-chart'),
    comparer: () => import('@/components/topo-components/comparer')
  },
  mounted() {
    //const { topDocs, filteredDocs } = this.$refs;
    // const { filteredDocs, items: insights, tocPages } = this.$refs;
    // const { filteredDocs, items: insights } = this.$refs;
    observer = new IntersectionObserver(this.enterView, { rootMargin: '0px 50% 0px 50%' });
    /*let docWidth;
    let items;
    let itemWidth;
    let perPage;*/
    // const topScroll = () => {
    //   this.topDocVisible = arrayFromScrollLeft(topDocs.scrollLeft);
    // };
    // const filterScroll = () => {
    //   this.filteredDocsVisible = arrayFromScrollLeft(filteredDocs.scrollLeft);
    // };
    // console.log('tocPages', tocPages);
    // const tocScroll = () => {
    //   console.log(tocPages.scrollTop);
    //   this.tocDocsVisible = arrayFromScrollTop(tocPages.scrollTop);
    // };
    // const insightsScroll = () => {
    //   this.ready = true;
    //   this.scrolled = new Date() * 1;
    // };
    // topDocs.addEventListener('scroll', topScroll);
    //filteredDocs.addEventListener('scroll', filterScroll);
    //insights.addEventListener('scroll', insightsScroll);
    //tocPages.addEventListener('scroll', tocScroll);
    this.$nextTick(init);
    function init() {
      // docWidth = docWidth || filteredDocs.getBoundingClientRect().width;
      // items = items || Array.from(filteredDocs.querySelectorAll('.item'), item => item.getBoundingClientRect().left);
      // itemWidth = itemWidth || items[1] - items[0];
      // perPage = perPage || Math.ceil(2 * (docWidth / itemWidth));
      // topScroll();
      // filterScroll();
      // insightsScroll();
      // this.tocScroll();
      const decrement = () => {
        --this.lazyLevel && setTimeout(decrement, 100);
        /*if (this.lazyLevel === 90) {
          console.log('lazyLevel', this.lazyLevel);
          const { filteredDocs } = this.$refs;
          const filterScroll = () => {
            try {
              this.filteredDocsVisible = arrayFromScrollLeft(filteredDocs.scrollLeft);
              console.log('filterScroll', this.filteredDocsVisible);
            } catch (ex) {}
          };
          filteredDocs.addEventListener('scroll', filterScroll);
          docWidth = docWidth || filteredDocs.getBoundingClientRect().width;
          items =
            items || Array.from(filteredDocs.querySelectorAll('.item'), item => item.getBoundingClientRect().left);
          itemWidth = itemWidth || items[1] - items[0];
          perPage = perPage || Math.ceil(2 * (docWidth / itemWidth));
          filterScroll();
          console.log('perPage', perPage, Object.entries(this.filteredDocsVisible).join(','));
        } else if (this.lazyLevel === 40) {
          const { $refs } = this;
          const { items: insights } = $refs;
          const insightsScroll = () => {
            this.ready = true;
            this.scrolled = new Date() * 1;
          };
          // todo: why is ?. needed?
          insights?.addEventListener('scroll', insightsScroll);
          insightsScroll();
          //this.tocScroll();
        }*/
      };
      decrement();
    }
    /*function arrayFromScrollLeft(scrollLeft) {
      const offset = Math.floor(scrollLeft / itemWidth);
      return Array.from(new Array(perPage), (item, i) => i + offset).reduce((map, item) => ({ ...map, [item]: 1 }), {});
      // let r = [];
      // try {
      // r = Array.from(new Array(perPage), (item, i) => i + offset).reduce((map, item) => ({ ...map, [item]: 1 }), {});
      // } catch (ex) {
      //todo: why does this happen?
      // }
      // return r;
    }*/
    //function arrayFromScrollTop(scrollTop) {
    //  const offset = Math.floor(scrollTop / 224);
    //  return Array.from(new Array(20), (item, i) => i + offset).reduce((map, item) => ({ ...map, [item]: 1 }), {});
    //}
  }
};
function isWinChrome() {
  return isWindows() && !!window.chrome;
}
function isWindows() {
  return /windows/i.test(navigator.userAgent);
}
</script>
<style lang="scss">
$brn: #8d6e4f;
.strip {
  .button-tab {
    background: white;
    user-select: none;
    &.selector .toggler {
      white-space: nowrap;
      width: 100%;
      background: no-repeat top left
        url('data:image/png;base64,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');
      background-size: contain;
    }
    &.list {
      label {
        text-transform: capitalize;
        text-align: left;
        display: block;
        padding-left: 2rem;
        position: relative;
        &.disabled {
          opacity: 0.5;
          pointer-events: none;
        }
        input[type='radio'] {
          position: absolute;
          left: 0;
        }
      }
    }
  }
  & > .blank {
    position: absolute;
    top: 10rem;
    left: 50%;
    width: 30vw;
    height: 30vw;
    transform: translate3d(-50%, 0, 0);
    opacity: 0.7;
    & > .logo {
      cursor: pointer;
      margin: 0.35rem;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      box-sizing: border-box;
      //padding-top: 57.02%;
      //bottom: 30%;
      z-index: 2;
      pointer-events: none;
      border-radius: 50%;
      opacity: 0.25;
      &.pulse {
        opacity: 1;
        & > .ring {
          opacity: 1;
        }
        & > .pulse-ring {
          opacity: 1;
          animation: pulse-animation 2s infinite;
        }
        &::before {
          opacity: 0.75;
        }
        &::after {
          opacity: 0;
        }
      }
      @keyframes pulse-animation {
        0% {
          transform: scale(1.05);
          border: 0.5rem solid #d9d9d9;
          //box-shadow: 0 0 0 0 rgba(200, 200, 200, 1);
        }
        50% {
          transform: scale(1.2);
          border: 0.5rem solid #d9d9d9;
          //box-shadow: 0 0 0 2.5rem rgba(0, 0, 0, 0);
        }
        100% {
          transform: scale(1.05);
          border: 0.5rem solid #d9d9d9;
          //box-shadow: 0 0 0 2rem rgba(0, 0, 0, 0);
        }
      }
      &.success {
        opacity: 1;
      }
      &::before {
        content: '';
        //display: inline-block;
        border: none;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        border-radius: 50%;
        z-index: -1;
        transition: opacity 500ms ease-in-out;
        //opacity: 0.1;
        //outline: 1px solid green;
        //width: 100%;
        //height: 100%;
        background: no-repeat center
        url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'0 0 208 208' version%3D'1.2'%3E%3Ccircle cx%3D'104' cy%3D'104' r%3D'104' fill%3D'%23e1e1e1'/%3E%3Ccircle cx%3D'104' cy%3D'104' r%3D'92.34' stroke%3D'%238d6e4f' stroke-width%3D'5' fill%3D'%238d6e4f'/%3E%3Cpath d%3D'M83.19,149.46c1.67,4.73-1.06,8.6-6.07,8.6H63.43a13.88,13.88,0,0,1-12.17-8.6L25,75.45c-1.68-4.73,1.05-8.6,6.07-8.6H44.75a13.87,13.87,0,0,1,12.17,8.6Z' fill%3D'white'/%3E%3Cpath d%3D'M58.44 149.46c-1.68 4.73 1.06 8.6 6.07 8.6h13.68a13.86 13.86 0 0 0 12.17-8.6l26.27-74c1.68-4.73-1.06-8.6-6.07-8.6H96.88a13.86 13.86 0 0 0-12.17 8.6zm65.37 0c-1.68 4.73 1 8.6 6.07 8.6h13.68a13.88 13.88 0 0 0 12.17-8.6l26.26-74c1.68-4.73-1.05-8.6-6.07-8.6h-13.68a13.87 13.87 0 0 0-12.17 8.6z' fill%3D'%23e1e1e1'/%3E%3Cpath d%3D'M150.07,149.46c1.68,4.73-1,8.6-6.07,8.6H130.32a13.87,13.87,0,0,1-12.17-8.6l-26.27-74c-1.67-4.73,1.06-8.6,6.08-8.6h13.68a13.88,13.88,0,0,1,12.17,8.6Z' fill%3D'white'/%3E%3C/svg%3E");
        //      url('data:image/png;base64,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');
        background-size: contain;
      }
      &::after {
        content: 'weave';
        position: absolute;
        top: 95%;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        font-size: 3rem;
        color: $brn;
        font-weight: 400;
      }
      & > .ring {
        position: absolute;
        top: -0.025rem;
        left: -0.025rem;
        bottom: -0.025rem;
        right: -0.025rem;
        border-radius: 50%;
        opacity: 0;
        //opacity: 0.5;
        //z-index: -1;
        box-sizing: border-box;
        border: 0.65rem solid white;
        transition: opacity 500ms ease-in-out;
        //transform: translate3d(0.125rem, 0, 0);
      }
      & > .pulse-ring {
        position: absolute;
        top: 0.6rem;
        left: 0.6rem;
        bottom: 0.6rem;
        right: 0.6rem;
        border-radius: 50%;
        opacity: 0;
        transition: opacity 500ms ease-in-out;
        //opacity: 0.5;
        z-index: 1;
        box-sizing: border-box;
        //border: 0.65rem solid green;
        //background-color: orange;

        //transform: translate3d(0.125rem, 0, 0);
      }
    }
  }
  & > .charts {
    position: fixed;
    top: 4.5rem;
    bottom: 0;
    width: 100vw;
    overflow: auto;
    //background-color: white;
    z-index: 16001;
    pointer-events: none;
    opacity: 0;
    transition: opacity 250ms ease-in-out;
    will-change: opacity;
    &.shown {
      opacity: 1;
      pointer-events: all;
    }
    &.see-through {
      pointer-events: none;
    }
  }
  .analysis {
    .button-tab,
    .tab-content,
    .button-tab.selected > .toggler::before {
      background-color: #f8f8f8;
    }
    .items {
      .item {
        .selectors > .copy {
          transform: translate3d(-2rem, -1.7rem, 0);
        }
        li > .copy {
          position: absolute;
          bottom: 0.25rem;
          right: 0.5rem;
          .paper {
            opacity: 0;
          }
        }
        li:hover > .copy .paper {
          opacity: 0.35;
        }

      }
    }
  }
}
</style>
<style scoped lang="scss">
@import '../scss/global';
//@import '../scss/cheatsheet';
.strip {
  padding-top: 4rem;
  padding-bottom: 4rem;
  &.for-folderlist {
    .analysis {
      margin-top: 0;
      .headers {
        pointer-events: none;
        opacity: 0;
        padding-top: 0 !important;
        height: 1px !important;
        margin: 0 0 0 0 !important;
        //display: none;
      }
      /deep/ {
        .viewer {
          height: 100vh;
          .single {
            height: 100%;
            overflow: visible;
            overflow-y: auto;
            .pdf-cards {
              height: 180vh;
            }
          }
        }
      }
    }
  }

  /*.options {*/
  /*  background-color: white;*/
  /*  position: fixed;*/
  /*  top: 5rem;*/
  /*  right: 0.5rem;*/
  /*  border: 1px solid #cecece;*/
  /*  border-radius: 0.25rem;*/
  /*  padding: 0.5rem 0 0.5rem 0.5rem;*/
  /*  z-index: 3;*/
  /*  .tabs {*/
  /*    display: grid;*/
  /*    grid-template-columns: repeat(2, auto);*/
  /*  }*/
  /*}*/
  // .share {
  //   cursor: pointer;
  //   color: $brn;
  //   padding: 0.125rem 0.25rem 0.125rem 1.5rem;
  //   background-position: left center;
  //   border: 1px solid $brn;
  //   border-radius: 3px;
  // }
  .theme-builder {
    padding: 4rem;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10000;
    background-color: rgba(#282828, 0.8);
    transform: translate3d(-150vw, 0, 0);
    transition: transform 400ms ease-in-out;
    pointer-events: none;
    &.shown {
      transform: translate3d(0, 0, 0);
      pointer-events: all;
    }
    .themer {
      position: relative;
      box-sizing: border-box;
      padding: 2rem;
      text-align: left;
      width: calc(100vw - 8rem);
      height: calc(100vh - 8rem);
      background-color: white;
      & > .close {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 0.5rem 0.5rem;
        font-size: 1.5rem;
      }
      & > label.name {
        & > input {
          border: none;
          width: 50vw;
          font-size: 2rem;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .engage-publisher {
    background-color: rgba(white, 0.7);
    position: fixed;
    bottom: 0.5rem;
    right: 0.5rem;
    display: flex;
    border: 1px solid #cecece;
    border-radius: 0.25rem;
    box-shadow: 0 0 3px rgba(#282828, 0.5);
    padding: 0.25rem 0.5rem 0.25rem 0.25rem;
    z-index: 3;
    box-sizing: border-box;
    .logo {
      width: 4rem;
      padding-top: 40%;
      background: center no-repeat;
      background-size: contain;
      margin-right: 0.125rem;
    }
    .name {
      font-size: 0.8rem;
      align-self: center;
      & > .favorite {
        &.hide {
          pointer-events: none;
          path {
            opacity: 0;
          }
        }
        & > svg {
          cursor: pointer;
          position: absolute;
          top: 0.125rem;
          right: 0.125rem;
          //margin-left: 0.25rem;
          width: 16px;
          height: 16px;
          &.on,
          &:hover {
            path {
              fill: $brn;
            }
          }
          path {
            transition: all 250ms ease-in-out;
            fill: rgba($brn, 0.125);
          }
          //transform: scale(0.5);
        }
      }
    }
  }
  .doco-publisher {
    background-color: rgba(white, 0.7);
    position: fixed;
    bottom: 0.5rem;
    right: 0.5rem;
    display: flex;
    border: 1px solid #cecece;
    border-radius: 0.25rem;
    box-shadow: 0 0 3px rgba(#282828, 0.5);
    padding: 0.25rem 0.5rem;
    z-index: 3;
    box-sizing: border-box;
    .logo {
      width: 2rem;
      padding-top: 17%;
      background: center no-repeat;
      background-size: contain;
      margin-right: 0.125rem;
    }
    .name {
      align-self: center;
    }
  }
  a.url {
    text-decoration: none;
    color: $brn;
    padding: 0.125rem 0.25rem;
    display: inline-block;
  }
  .docs {
    position: relative;
    .info {
      .count {
        position: absolute;
        right: 1rem;
        top: 0.5rem;
        color: rgba($brn, 0.7);
        .primary {
          color: $brn;
        }
        .value {
          font-weight: bold;
        }
        * {
          display: inline;
        }
      }
    }
    .options {
      background-color: white;
      position: absolute;
      top: 5rem;
      right: 0.5rem;
      display: flex;
      border: 1px solid #cecece;
      border-radius: 0.25rem;
      padding: 0.5rem 0 0.5rem 0.5rem;
      z-index: 3;
      // a.cheatsheet-preview {
      //   max-height: 1.25rem;
      //   margin-right: 0.5rem;
      //   margin-top: 0.125rem;
      //   text-decoration: none;
      //   color: $brn;
      //   padding: 0.125rem 0.4rem;
      //   border: 1px solid $brn;
      //   border-radius: 3px;
      // }
      .share {
        background-color: white;
        // color: $brn;
        // max-height: 1.25rem;
        // margin-right: 0.5rem;
        // margin-top: 0.125rem;
        // will-change: transform;
        // transform-origin: center;
        // background-color: white;
        // &.pressed {
        //   transition: transform 250ms ease-in-out;
        //   //transform: scale(0.8) rotate(360deg);
        //   transform: rotate(360deg);
        //   //border: 4px solid blue;
        // }
      }
      .tabs {
        display: grid;
        grid-template-columns: repeat(2, auto);
      }
    }
    .items {
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      /*padding: 3.5rem 0.5rem;*/
      padding: 2rem 0.5rem;
      display: grid;
      grid-template-columns: repeat(1200, 25%);
      //grid-template-rows: 1;
      grid-gap: 0 1%;
      .item {
        background: no-repeat top left white;
        // box-shadow: 1px 1px 1px #eee;
        // outline: 1px solid #eee;
        width: 100%;
        padding-top: 133%;
        background-size: contain;
        position: relative;
        cursor: pointer;
        outline: 1px solid #ddd;
        box-shadow: 1px 1px 1px #ddd;
        &.selected {
          outline: 2px solid orange;
          box-shadow: 1px 1px 3px #282828;
        }
        //cursor: default;
        //&.selected {
        //  outline: 2px solid orange;
        //  box-shadow: 1px 1px 3px #282828;
        //}
        // &::before {
        //   position: absolute;
        //   font-size: 1.3rem;
        //   top: 0.5rem;
        //   right: 0.5rem;
        // }
        // &:hover::before {
        //   content: 'view pdf';
        //   color: white;
        //   cursor: pointer;
        //   text-shadow: 1px 1px 0 $brn, -1px -1px 0 $brn, -1px 1px 0 $brn, 1px -1px 0 $brn;
        // }
        .goto-pdf {
          position: absolute;
          font-size: 1.3rem;
          bottom: 0.5rem;
          left: 50%;
          color: white;
          cursor: pointer;
          transform: translate3d(-50%, 0, 0);
          opacity: 0;
          transition: opacity 400ms ease-in-out;
          will-change: opacity;
          text-shadow: 1px 1px 0 $brn,
                       -1px -1px 0 $brn,
                       -1px 1px 0 $brn,
                       1px -1px 0 $brn;
        }
        &:hover {
          .goto-pdf {
            opacity: 1;
          }
        }
        .goto-insight {
          position: absolute;
          font-size: 1.3rem;
          top: 0.5rem;
          right: 0.25rem;
          // pointer-events: none;
          /* color: transparent; */
          color: #8d6e4f;
          /* font-size: 0; */
          font-size: 1.5rem;
          height: 1.9rem;
          width: 1.9rem;
          background-color: white;
          border: 1px solid #8d6e4f;
          border-radius: 0.125rem 50% 50% 50%;
          transform: rotate(45deg) scale(0.8);
          transform-origin: center;
          text-shadow: none;
        }
        &.has-insight,
        &.it-has-a-tooltip {
          // cursor: pointer;
          // outline: 1px solid #ddd;
          // box-shadow: 1px 1px 1px #ddd;
          // &.selected {
          //   outline: 2px solid orange;
          //   box-shadow: 1px 1px 3px #282828;
          // }

          // &::before {
          //   right: 0.25rem;
          //   pointer-events: none;
          //   content: '\a4';
          //   /* color: transparent; */
          //   color: #8d6e4f;
          //   /* font-size: 0; */
          //   font-size: 1.5rem;
          //   height: 1.9rem;
          //   width: 1.9rem;
          //   background-color: white;
          //   border: 1px solid #8d6e4f;
          //   border-radius: 0.125rem 50% 50% 50%;
          //   transform: rotate(45deg) scale(0.8);
          //   transform-origin: center;
          //   text-shadow: none;
          // }
        }
      }
    }
  }
  .headers {
    //padding-left: 1.5rem;
    /*display: grid;*/
    /*grid-template-columns: repeat(3, 14rem);*/
    background-color: #f8f8f8;
    padding-top: 3rem;
    text-align: left;
    &.top {
      background-color: white;
      padding-top: 1rem;
      margin-bottom: -1rem;
    }
    .header {
      cursor: pointer;
      display: inline-block;
      text-align: center;
      font-size: 2.6rem;
      font-weight: bold;
      color: white;
      text-shadow: 1px 1px 1px $brn,
                   -1px -1px 1px $brn,
                   -1px 1px 1px $brn,
                   1px -1px 1px $brn;
      position: relative;
      padding: 0 2rem;
      &:hover:not(.selected),
      &.selected {
        transition: color 250ms ease-in-out;
        color: lighten($brn, 30%);
        text-shadow: 1px 1px 0 $brn,
                     -1px -1px 0 $brn,
                     -1px 1px 0 $brn,
                     1px -1px 0 $brn;
      }
      &::after {
        content: '\a0';
        position: absolute;
        height: 1.2rem;
        width: 1.2rem;
        left: 100%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        //margin-left: 1rem;
        border: 1px solid $brn;
        border-radius: 50%;
      }
      &:last-of-type::after {
        display: none;
      }
    }
  }
  .analysis {
    margin-top: 3rem;
    box-shadow: 0 0 8px rgba($brn, 0.5);
    background-color: #f8f8f8;
    .inherit {
      color: #444;
      position: absolute;
      right: 1rem;
      transform: translate3d(0, 52%, 0);
      text-align: right;
      padding-right: 1rem;
      z-index: 5;
    }
    .views {
      overflow: hidden;
      .viewport {
        &.cloud {
          transform: translate3d(-100vw, 0, 0);
        }
        &:not(.for-folderlist) {
          margin-top: 4rem;
          display: grid;
          grid-template-columns: repeat(3, 100vw);
          transform: translate3d(0, 0, 0);
          will-change: transform;
          transition: transform 400ms ease-in-out;
        }
        &.pdfView {
          transform: translate3d(-200vw, 0, 0);
        }
      }
    }
    //@import '../scss/insights';
    .tag-cloud {
      user-select: none;
      //background-color: white;
      height: 70%;
      padding: 6rem;
      //position: fixed;
      //top: 0;
      //left: 0;
      //bottom: 0;
      //right: 0;
      //transform: translate3d(-100%, 0, 0);
      //transition: transform 400ms ease-in-out;
      //will-change: transform;
      &.cloud {
        //transform: translate3d(0, 0, 0);
      }
      @include large {
        //top: $headerHeight;
      }
      .word {
        cursor: pointer;
        transform-origin: center;
        transition: transform 200ms ease-in-out 200ms;
        will-change: transform;
        &:hover {
          transform: scale(1.2);
          //outline: 1px solid black;
        }
      }
    }
  }
  /*.viewer {
    padding-top: 4rem;
    display: grid;
    grid-template-columns: 12.5rem 85%;
    background-color: #888;
    position: relative;
    .zoom-level {
      cursor: pointer;
      position: absolute;
      top: 2rem;
      left: 12.5rem;
      padding: 0.125rem 0.25rem;
      border: 1px solid white;
      border-radius: 3px;
      color: white;
      font-weight: bold;
    }
    .toc {
      height: 1812.52px;
      overflow: auto;
      .pages {
        box-sizing: border-box;
        padding: 0.4rem 1rem 0.25rem;
        .page {
          cursor: pointer;
          height: 14rem;
          background: white no-repeat center;
          background-size: contain;
          margin-bottom: 0.25rem;
          box-shadow: 1px 1px 6px #777;
          opacity: 0.7;
          &.enabled {
            opacity: 1;
          }
          &.selected {
            outline: 0.4rem solid orange;
            .number {
              background-color: transparent;
            }
          }
          .number {
            box-sizing: border-box;
            height: 100%;
            font-size: 4rem;
            font-weight: bold;
            text-align: center;
            padding-top: 5rem;
            color: white;
            background-color: rgba(255, 255, 255, 0.4);
            text-shadow: 1px 1px 0 #bababa, -1px -1px 0 #bababa, 0 1px 0 #bababa, 1px 0 0 #bababa, 0 -1px 0 #bababa,
              -1px 0 0 #bababa, 1px 1px 1px #bababa, -1px -1px 1px #bababa, 0 1px 1px #bababa, 1px 0 1px #bababa,
              0 -1px 1px #bababa, -1px 0 1px #bababa;
          }
        }
      }
    }
    .pdf {
      transform-origin: top center;
      box-shadow: 7px 7px 7px #777;
    }
    .next,
    .previous,
    .current {
      position: absolute;
      z-index: 5;
      color: white;
      font-size: 2.5rem;
      font-weight: bold;
      cursor: default;
      padding: 0.25rem 0.75rem;
      border: 1px solid transparent;
      border-radius: 0.25rem;
      text-shadow: 1px 1px 0 #bababa, -1px -1px 0 #bababa, 0 1px 0 #bababa, 1px 0 0 #bababa, 0 -1px 0 #bababa,
        -1px 0 0 #bababa, 1px 1px 1px #bababa, -1px -1px 1px #bababa, 0 1px 1px #bababa, 1px 0 1px #bababa,
        0 -1px 1px #bababa, -1px 0 1px #bababa;
      opacity: 0.7;
      &.enabled {
        opacity: 1;
      }
      &:hover:not(.current) {
        cursor: pointer;
        border-color: $brn;
        background-color: white;
        text-shadow: none;
        color: $brn;
        box-shadow: 0 0 3px $brn;
        not-text-shadow: 1px 1px 0 black, -1px -1px 0 black, 0 1px 0 black, 1px 0 0 black, 0 -1px 0 black,
          -1px 0 0 black, 1px 1px 1px black, -1px -1px 1px black, 0 1px 1px black, 1px 0 1px black, 0 -1px 1px black,
          -1px 0 1px black;
      }
      &.top {
        top: 4.75rem;
      }
      &.bottom {
        bottom: 2.75rem;
      }
      &.next {
        right: 3.5rem;
      }
      &.previous {
        left: 13.5rem;
      }
      &.current {
        color: $brn;
        text-shadow: none;
        border-color: $brn;
        border-radius: 0.25rem;
        background-color: white;
        box-shadow: 0 0 3px $brn;
        opacity: 1 !important;
        margin-left: 5%;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
      }
    }
  }*/
  .tag-bar {
    //transform: translate3d(0, 2rem, 0);
    margin-top: 1rem;
    padding-left: 1rem;
    .filters {
      display: flex;
      &.searchFocus {
        @include small {
          opacity: 0;
        }
      }
      .filter {
        position: relative;
        padding: 0.6rem 0.8rem 0.5rem;
        background-color: white;
        color: $brn;
        border-radius: 0.5rem;
        cursor: pointer;
        margin: 0 0.5rem;
        box-sizing: border-box;
        @include small {
          margin: 0 0.25rem;
        }
        &.tag {
          padding-right: 1.5rem;
          border: 1px solid $brn;
          &::after {
            content: '\00d7';
            position: absolute;
            top: 50%;
            right: 0.6rem;
            margin-top: -0.05rem;
            transform: translate3d(0, -50%, 0);
          }
        }
        &.command {
          cursor: pointer;
          display: block;
          font-size: 0;
          padding: 0;
          color: transparent;
          height: 2.4rem;
          width: 2.4rem;
          border: 1px solid $brn;
          //border-radius: 100%;
          position: relative;
          //margin-top: 0.125rem;
          //background: $brn no-repeat center
          //url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'-128 -256 1792 1792' width%3D'100%' height%3D'100%'%3E%3Cpath fill%3D'%23fff' d%3D'm 1216,576 v 128 q 0,26 -19,45 -19,19 -45,19 H 896 v 256 q 0,26 -19,45 -19,19 -45,19 H 704 q -26,0 -45,-19 -19,-19 -19,-45 V 768 H 384 q -26,0 -45,-19 -19,-19 -19,-45 V 576 q 0,-26 19,-45 19,-19 45,-19 H 640 V 256 q 0,-26 19,-45 19,-19 45,-19 h 128 q 26,0 45,19 19,19 19,45 v 256 h 256 q 26,0 45,19 19,19 19,45 z m 320,64 Q 1536,431 1433,254.5 1330,78 1153.5,-25 977,-128 768,-128 559,-128 382.5,-25 206,78 103,254.5 0,431 0,640 0,849 103,1025.5 206,1202 382.5,1305 559,1408 768,1408 977,1408 1153.5,1305 1330,1202 1433,1025.5 1536,849 1536,640 z'/%3E%3C/svg%3E");
          //background-size: 107%;
          //transform: translate3d(20%, -75%, 0);
          //background-color: transparent;
          &::after {
            position: absolute;
            top: 50%;
            left: 50%;
            display: block;
            transform-origin: center;
            transform: rotate(45deg) translate3d(-115%, -28%, 0);
            color: $brn;
            font-size: 2rem;
            content: '\00d7';
            //text-shadow: 0 0 4px black;
          }
        }
      }
    }
    .open:not(.search) {
      position: relative;
      //right: 0.5rem;
      padding: 0.6rem 0.8rem 0.6rem 1.5rem;
      width: 3rem;
      background: white no-repeat 0.2rem center
        url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'-2 -256 1792 1792'%3E %3Cg transform%3D'matrix(1,0,0,-1,182.23729,1201.8983)'%3E %3Cpath fill%3D'%238d6e4f' d%3D'm 1403,1241 q 17,-41 -14,-70 L 896,678 V -64 q 0,-42 -39,-59 -13,-5 -25,-5 -27,0 -45,19 L 531,147 q -19,19 -19,45 V 678 L 19,1171 q -31,29 -14,70 17,39 59,39 h 1280 q 42,0 59,-39 z'/%3E  %3C/g%3E%3C/svg%3E");
      background-size: 25%;
      //font-weight: bold;
      color: $brn;
      z-index: 2;
      border: 1px solid $brn;
      border-radius: 0.5rem;
      cursor: pointer;
      &.searchFocus {
        @include small {
          opacity: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
// recovered
.strip .analysis .insights {
  background-color: #f8f8f8;
  position: relative
}

.strip .analysis .insights .nav {
  z-index: 1;
  position: absolute;
  top: -1.5rem;
  left: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 2rem;
  width: 4rem;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-left: -2rem
}

.strip .analysis .insights .nav> {
  padding: 1rem;
  cursor: pointer
}

.strip .analysis .insights .count {
  position: absolute;
  right: 1rem;
  color: rgba(141,110,79,.4)
}

.strip .analysis .insights .count .primary {
  color: #8d6e4f
}

.strip .analysis .insights .count .value {
  font-weight: 700
}

.strip .analysis .insights .count  {
  display: inline
}

.strip .analysis .insights .cheatsheet-controls {
  position: absolute;
  top: -.25rem;
  right: 15rem;
  z-index: 2
}

.strip .analysis .insights > .items {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  height: 110vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column wrap;
  flex-flow: column wrap;
  padding-top: 2vw;
  padding-bottom: 2vw;
  padding-left: 2vw;
  will-change: transform;
  position: relative
}

.strip .analysis .insights > .items.animate {
  -webkit-transition: -webkit-transform .3s ease-in-out;
  transition: -webkit-transform .3s ease-in-out;
  transition: transform .3s ease-in-out;
  transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out
}

.strip .analysis .insights > .items.sharing .item li:not(.selected):before {
  border: 1px solid #dadada
}

.strip .analysis .insights > .items.sharing .item li.selected:before {
  border-left-width: .5rem;
  border-color: orange
}

.strip .analysis .insights > .items.sharing .item .selectors {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex
}

.strip .analysis .insights > .items .count {
  top: .5rem
}

.strip .analysis .insights > .items .item {
  cursor: pointer;
  background: no-repeat left 2rem #fff;
  background-size: 21vw;
  padding: .35vw;
  padding-top: 2rem;
  padding-left: 21vw;
  padding-right: 2vw;
  margin-right: 2vw;
  margin-bottom: .25vw;
  width: 21vw;
  min-height: 27vw;
  -webkit-box-shadow: 1px 1px 5px #ccc;
  box-shadow: 1px 1px 5px #ccc;
  position: relative
}

.strip .analysis .insights > .items .item .show-more li.more {
  display: block
}

.strip .analysis .insights > .items .item:after {
  content: attr(pgn);
  position: absolute;
  top: 6.5rem;
  left: 0;
  width: 21vw;
  text-align: center;
  font-size: 6vw;
  color: #fff;
  font-weight: 700;
  text-shadow: 1px 1px 1px #bababa,-1px -1px 1px #bababa,-1px 1px 1px #bababa,1px -1px 1px #bababa
}

.strip .analysis .insights > .items .item .selectors {
  position: absolute;
  top: .5rem;
  right: 1.8rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 21vw;
  display: none;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  padding: .25rem .5rem;
  color: #8d6e4f
}

.strip .analysis .insights > .items .item ul {
  height: 97%
}

.strip .analysis .insights > .items .item ul li {
  position: relative;
  list-style: circle;
  margin-bottom: .5rem;
  text-align: left
}

.strip .analysis .insights > .items .item ul li.more {
  display: none
}

.strip .analysis .insights > .items .item ul li:before {
  content: " ";
  position: absolute;
  top: -.25rem;
  left: -2rem;
  bottom: -.25rem;
  right: -.25rem;
  border: 2px solid transparent;
  border-radius: 3px
}

.strip .analysis .insights > .items .item ul li:after {
  content: "¤";
  color: #8d6e4f;
  font-size: 1.5rem;
  height: 1.9rem;
  width: 1.9rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  background-color: #fff;
  border: 1px solid #8d6e4f;
  border-radius: .125rem 50% 50% 50%;
  -webkit-transform: rotate(45deg) scale(.4);
  transform: rotate(45deg) scale(.4);
  -webkit-transform-origin: center;
  transform-origin: center;
  position: absolute;
  top: -.25rem;
  left: -1.95rem
}

.strip .analysis .insights > .items .item ul li span.theme {
  color: #8d6e4f;
  font-weight: 700;
  display: inline-block;
  margin: -2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 2px;
  border-radius: 2px
}


.strip .analysis .tag-cloud {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 70%;
  padding: 6rem
}

.strip .analysis .tag-cloud .word {
  cursor: pointer;
  -webkit-transform-origin: center;
  transform-origin: center;
  -webkit-transition: -webkit-transform .2s ease-in-out .2s;
  transition: -webkit-transform .2s ease-in-out .2s;
  transition: transform .2s ease-in-out .2s;
  transition: transform .2s ease-in-out .2s,-webkit-transform .2s ease-in-out .2s;
  will-change: transform
}

.strip .analysis .tag-cloud .word:hover {
  -webkit-transform: scale(1.2);
  transform: scale(1.2)
}

.strip .tag-bar {
  margin-top: 1rem;
  padding-left: 1rem
}

.strip .tag-bar .filters {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex
}

@media screen and (max-width: 480px) {
  .strip .tag-bar .filters.searchFocus {
    opacity:0
  }
}

.strip .tag-bar .filters .filter {
  position: relative;
  padding: .6rem .8rem .5rem;
  background-color: #fff;
  color: #8d6e4f;
  border-radius: .5rem;
  cursor: pointer;
  margin: 0 .5rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box
}

@media screen and (max-width: 480px) {
  .strip .tag-bar .filters .filter {
    margin:0 .25rem
  }
}

.strip .tag-bar .filters .filter.tag {
  padding-right: 1.5rem;
  border: 1px solid #8d6e4f
}

.strip .tag-bar .filters .filter.tag:after {
  content: "×";
  position: absolute;
  top: 50%;
  right: .6rem;
  margin-top: -.05rem;
  -webkit-transform: translate3d(0,-50%,0);
  transform: translate3d(0,-50%,0)
}

.strip .tag-bar .filters .filter.command {
  cursor: pointer;
  display: block;
  font-size: 0;
  padding: 0;
  color: transparent;
  height: 2.4rem;
  width: 2.4rem;
  border: 1px solid #8d6e4f;
  position: relative
}

.strip .tag-bar .filters .filter.command:after {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  -webkit-transform-origin: center;
  transform-origin: center;
  -webkit-transform: rotate(45deg) translate3d(-115%,-28%,0);
  transform: rotate(45deg) translate3d(-115%,-28%,0);
  color: #8d6e4f;
  font-size: 2rem;
  content: "×"
}

.strip .tag-bar .open:not(.search) {
  position: relative;
  padding: .6rem .8rem .6rem 1.5rem;
  width: 3rem;
  background: #fff no-repeat .2rem url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'-2 -256 1792 1792'%3E %3Cg transform%3D'matrix(1,0,0,-1,182.23729,1201.8983)'%3E %3Cpath fill%3D'%238d6e4f' d%3D'm 1403,1241 q 17,-41 -14,-70 L 896,678 V -64 q 0,-42 -39,-59 -13,-5 -25,-5 -27,0 -45,19 L 531,147 q -19,19 -19,45 V 678 L 19,1171 q -31,29 -14,70 17,39 59,39 h 1280 q 42,0 59,-39 z'/%3E  %3C/g%3E%3C/svg%3E");
  background-size: 25%;
  color: #8d6e4f;
  z-index: 2;
  border: 1px solid #8d6e4f;
  border-radius: .5rem;
  cursor: pointer
}

@media screen and (max-width: 480px) {
  .strip .tag-bar .open:not(.search).searchFocus {
    opacity:0
  }
}

.share {
  background: no-repeat 50% url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'0 0 50 50' enable-background%3D'new 0 0 50 50'%3E%3Cg style%3D'fill: %238d6e4f;'%3E%3Cpath d%3D'M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z'/%3E%3Cpath d%3D'M24 7h2v21h-2z'/%3E%3Cpath d%3D'M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z'/%3E%3C/g%3E%3C/svg%3E");
  background-size: contain
}

.delete {
  opacity: 0;
  cursor: default;
  pointer-events: none;
  background-color: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 0 3px #888,0 0 6px #888;
  box-shadow: 0 0 3px #888,0 0 6px #888;
  position: absolute;
  top: -.5rem;
  right: -.5rem;
  width: 1.25rem;
  height: 1.25rem;
  z-index: 2
}

.delete:before {
  content: " ";
  position: absolute;
  top: .125rem;
  left: .125rem;
  bottom: .125rem;
  right: .125rem;
  border-radius: 50%;
  background-color: orange;
  font-size: 0
}

.delete:after {
  content: " ";
  position: absolute;
  top: 50%;
  left: 20%;
  right: 20%;
  padding-top: 12%;
  font-size: 0;
  -webkit-transform: translate3d(0,-50%,0);
  transform: translate3d(0,-50%,0);
  background-color: #fff;
  border-radius: 2px
}

.share {
  cursor: pointer;
  padding: .125rem .25rem .125rem 1.5rem;
  background-position: 0;
  border: 1px solid #8d6e4f;
  border-radius: 3px;
  color: #8d6e4f;
  max-height: 1.25rem;
  margin-right: .5rem;
  margin-top: .125rem;
  will-change: transform;
  -webkit-transform-origin: center;
  transform-origin: center
}

.share.hidden {
  opacity: 0;
  pointer-events: none
}

.share.pressed {
  -webkit-transition: -webkit-transform .25s ease-in-out;
  transition: -webkit-transform .25s ease-in-out;
  transition: transform .25s ease-in-out;
  transition: transform .25s ease-in-out,-webkit-transform .25s ease-in-out;
  -webkit-transform: rotate(1turn);
  transform: rotate(1turn)
}

a.cheatsheet-preview {
  max-height: 1.25rem;
  margin-right: .5rem;
  text-decoration: none
}

.select,a.cheatsheet-preview {
  margin-top: .125rem;
  color: #8d6e4f;
  padding: .125rem .4rem;
  border: 1px solid #8d6e4f;
  border-radius: 3px
}

.select {
  cursor: pointer;
  z-index: 3
}

.select.on {
  color: #fff;
  background-color: rgba(141,110,79,.8)
}

.edit-save {
  background-color: #fff;
  border: 1px solid #cecece;
  border-radius: .25rem;
  padding: .3rem .5rem .5rem .5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  -webkit-box-shadow: 1px 1px 5px #ccc;
  box-shadow: 1px 1px 5px #ccc
}

.edit-save.dirty {
  border-color: #8d6e4f;
  -webkit-box-shadow: 1px 1px 5px #000;
  box-shadow: 1px 1px 5px #000
}

.edit-save.dirty .status {
  -webkit-transition: all .25s ease-in-out;
  transition: all .25s ease-in-out;
  opacity: 1;
  font-weight: 400
}

.edit-save .progress {
  -webkit-transition: width 1s ease-in-out;
  transition: width 1s ease-in-out;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 3%;
  border-radius: 1px;
  height: 4px;
  background-color: orange
}

.edit-save .status {
  -webkit-transition: all .25s ease-in-out 2s;
  transition: all .25s ease-in-out 2s;
  opacity: .75;
  font-weight: 200;
  padding: .25rem;
  margin-right: .75rem
}

.share {
  background: no-repeat 50% url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'0 0 50 50' enable-background%3D'new 0 0 50 50'%3E%3Cg style%3D'fill: %238d6e4f;'%3E%3Cpath d%3D'M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z'/%3E%3Cpath d%3D'M24 7h2v21h-2z'/%3E%3Cpath d%3D'M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z'/%3E%3C/g%3E%3C/svg%3E");
  background-size: contain
}

.delete {
  opacity: 0;
  cursor: default;
  pointer-events: none;
  background-color: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 0 3px #888,0 0 6px #888;
  box-shadow: 0 0 3px #888,0 0 6px #888;
  position: absolute;
  top: -.5rem;
  right: -.5rem;
  width: 1.25rem;
  height: 1.25rem;
  z-index: 2
}

.delete:before {
  content: " ";
  position: absolute;
  top: .125rem;
  left: .125rem;
  bottom: .125rem;
  right: .125rem;
  border-radius: 50%;
  background-color: orange;
  font-size: 0
}

.delete:after {
  content: " ";
  position: absolute;
  top: 50%;
  left: 20%;
  right: 20%;
  padding-top: 12%;
  font-size: 0;
  -webkit-transform: translate3d(0,-50%,0);
  transform: translate3d(0,-50%,0);
  background-color: #fff;
  border-radius: 2px
}

.strip .docs .info .count .primary {
  color: #8d6e4f
}

.strip .docs .info .count .value {
  font-weight: 700
}

.strip .analysis .insights .count .primary {
  color: #8d6e4f
}

.strip .analysis .insights .count .value {
  font-weight: 700
}

.strip .analysis .insights .count  {
  display: inline
}

.strip .analysis .insights .cheatsheet-controls {
  position: absolute;
  top: -.25rem;
  right: 15rem;
  z-index: 2
}

.strip .analysis .insights .count {
  position: absolute;
  right: 1rem;
  color: rgba(141,110,79,.4)
}

.strip .analysis .insights .count .primary {
  color: #8d6e4f
}

.strip .analysis .insights .count .value {
  font-weight: 700
}

.strip .analysis .insights .count * {
  display: inline
}


.select,a.cheatsheet-preview {
  margin-top: .125rem;
  color: #8d6e4f;
  padding: .125rem .4rem;
  border: 1px solid #8d6e4f;
  border-radius: 3px
}

.select {
  cursor: pointer;
  z-index: 3
}

.select.on {
  color: #fff;
  background-color: rgba(141,110,79,.8)
}


.strip .analysis .insights .cheatsheet-controls[data-v-0b23ba6d] {
  position: absolute;
  top: -.25rem;
  right: 15rem;
  z-index: 2
}


</style>
<style>
.vue-slider-component{position:relative;box-sizing:border-box;-ms-user-select:none;user-select:none;-webkit-user-select:none;-moz-user-select:none;-o-user-select:none}.vue-slider-component.vue-slider-disabled{opacity:.5;cursor:not-allowed}.vue-slider-component.vue-slider-has-label{margin-bottom:15px}.vue-slider-component.vue-slider-disabled .vue-slider-dot{cursor:not-allowed}.vue-slider-component .vue-slider{position:relative;display:block;border-radius:15px;background-color:#ccc}.vue-slider-component .vue-slider:after{content:"";position:absolute;left:0;top:0;width:100%;height:100%;z-index:2}.vue-slider-component .vue-slider-process{position:absolute;border-radius:15px;background-color:#3498db;transition:all 0s;z-index:1}.vue-slider-component .vue-slider-process.vue-slider-process-dragable{cursor:pointer;z-index:3}.vue-slider-component.vue-slider-ltr .vue-slider-process{width:0;height:100%;top:0;left:0;will-change:width}.vue-slider-component.vue-slider-vertical .vue-slider-process{width:100%;height:0;bottom:0;left:0;will-change:height}.vue-slider-component.vue-slider-ltr-reverse .vue-slider-process{width:0;height:100%;top:0;right:0}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-process{width:100%;height:0;top:0;left:0}.vue-slider-component .vue-slider-dot{position:absolute;transition:all 0s;will-change:transform;cursor:pointer;z-index:5}.vue-slider-component .vue-slider-dot .vue-slider-dot-handle{width:100%;height:100%;border-radius:50%;background-color:#fff;box-shadow:.5px .5px 2px 1px rgba(0,0,0,.32)}.vue-slider-component .vue-slider-dot.vue-slider-dot-focus .vue-slider-dot-handle{box-shadow:0 0 2px 1px #3498db}.vue-slider-component .vue-slider-dot--static .vue-slider-dot-handle--static{width:100%;height:100%;border-radius:50%;background-color:#ccc;transform:scale(.85)}.vue-slider-component .vue-slider-dot--static.vue-slider-dot-active .vue-slider-dot-handle--static{width:100%;height:100%;border-radius:50%;background-color:#3498db;transform:scale(.85)}.vue-slider-component .vue-slider-dot.vue-slider-dot-dragging{z-index:5}.vue-slider-component .vue-slider-dot.vue-slider-dot-disabled{z-index:4}.vue-slider-component.vue-slider-ltr .vue-slider-dot{left:0}.vue-slider-component.vue-slider-vertical .vue-slider-dot{bottom:0}.vue-slider-component.vue-slider-ltr-reverse .vue-slider-dot{right:0}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-dot{top:0}.vue-slider-component .vue-slider-tooltip-wrap{display:none;position:absolute;z-index:9}.vue-slider-component .vue-slider-dot--static:hover .vue-slider-tooltip-wrap{display:block}.vue-slider-component .vue-slider-tooltip{display:block;font-size:14px;white-space:nowrap;padding:2px 5px;min-width:20px;text-align:center;color:#fff;border-radius:5px;border:1px solid #3498db;background-color:#3498db}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top{top:-9px;left:50%;transform:translate(-50%,-100%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-bottom{bottom:-9px;left:50%;transform:translate(-50%,100%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-left{top:50%;left:-9px;transform:translate(-100%,-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-right{top:50%;right:-9px;transform:translate(100%,-50%)}.vue-slider-component .vue-slider-tooltip-top .vue-merged-tooltip .vue-slider-tooltip:before,.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top .vue-slider-tooltip:before{content:"";position:absolute;bottom:-10px;left:50%;width:0;height:0;border:5px solid transparent;border:6px solid transparent\0;border-top-color:inherit;transform:translate(-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-merged-tooltip{display:block;visibility:hidden}.vue-slider-component .vue-slider-tooltip-bottom .vue-merged-tooltip .vue-slider-tooltip:before,.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-bottom .vue-slider-tooltip:before{content:"";position:absolute;top:-10px;left:50%;width:0;height:0;border:5px solid transparent;border:6px solid transparent\0;border-bottom-color:inherit;transform:translate(-50%)}.vue-slider-component .vue-slider-tooltip-left .vue-merged-tooltip .vue-slider-tooltip:before,.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-left .vue-slider-tooltip:before{content:"";position:absolute;top:50%;right:-10px;width:0;height:0;border:5px solid transparent;border:6px solid transparent\0;border-left-color:inherit;transform:translateY(-50%)}.vue-slider-component .vue-slider-tooltip-right .vue-merged-tooltip .vue-slider-tooltip:before,.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-right .vue-slider-tooltip:before{content:"";position:absolute;top:50%;left:-10px;width:0;height:0;border:5px solid transparent;border:6px solid transparent\0;border-right-color:inherit;transform:translateY(-50%)}.vue-slider-component .vue-slider-dot.vue-slider-hover:hover .vue-slider-tooltip-wrap{display:block}.vue-slider-component .vue-slider-dot.vue-slider-always .vue-slider-tooltip-wrap{display:block!important}.vue-slider-component .vue-slider-piecewise{position:absolute;width:100%;padding:0;margin:0;left:0;top:0;height:100%;list-style:none}.vue-slider-component .vue-slider-piecewise-item{position:absolute;width:8px;height:8px}.vue-slider-component .vue-slider-piecewise-dot{position:absolute;left:50%;top:50%;width:100%;height:100%;display:inline-block;background-color:rgba(0,0,0,.16);border-radius:50%;transform:translate(-50%,-50%);z-index:2;transition:all .3s}.vue-slider-component .vue-slider-piecewise-item:first-child .vue-slider-piecewise-dot,.vue-slider-component .vue-slider-piecewise-item:last-child .vue-slider-piecewise-dot{visibility:hidden}.vue-slider-component.vue-slider-ltr-reverse .vue-slider-piecewise-label,.vue-slider-component.vue-slider-ltr .vue-slider-piecewise-label{position:absolute;display:inline-block;top:100%;left:50%;white-space:nowrap;font-size:12px;color:#333;transform:translate(-50%,8px);visibility:visible}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-piecewise-label,.vue-slider-component.vue-slider-vertical .vue-slider-piecewise-label{position:absolute;display:inline-block;top:50%;left:100%;white-space:nowrap;font-size:12px;color:#333;transform:translate(8px,-50%);visibility:visible}.vue-slider-component .vue-slider-sr-only{clip:rect(1px,1px,1px,1px);height:1px;width:1px;overflow:hidden;position:absolute!important}
</style>